export default{
    formatNumber(num, decimal){
        return (Math.floor(parseFloat(num) * Math.pow(10, decimal))/Math.pow(10, decimal)).toFixed(decimal);
    },

    formatNumberWithCommas(num, decimal){
        let number = this.formatNumber(num, decimal);
        
        let nStr = number.toString();
        var x = nStr.split('.')
        var x1 = x[0]
        var x2 = x.length > 1 ? '.' + x[1] : ''
        var rgx = /(\d+)(\d{3})/
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2')
        }
        return x1 + x2
    }
}